<!-- <mat-form-field>
  <mat-select [(value)]="selection" (selectionChange)="onChange($event)" (openedChange)="triggerEvent($event)" #select multiple [disabled]="isDisabled">
    <mat-select-trigger>
      Selected Count : {{selection.length}}
    </mat-select-trigger>
    <div id="wrapper"><input (keyup)="onKey($event.target.value)" (keydown)="$event.stopPropagation()" #search></div>
    <div class="select-all">
      <mat-checkbox [(ngModel)]="allSelected" [ngModelOptions]="{standalone: true}" (change)="toggleAllSelection()">
        Select All
      </mat-checkbox>
    </div>
    <mat-option *ngFor="let val of newList" [value]="val"  (click)="optionClick()">
      <span class="no-wrap" eipTooltip="{{val}}" eipTooltipPosition="auto">
        {{val}}                
      </span>
    </mat-option>
  </mat-select>
</mat-form-field>  -->

<EIPMultiSelectAutoComplete [dataSource]="newlist2" setId="dghRoleid" TextField="name"
  ValueField="id" WaterMarkText="" ShowTextValueField='N' isEmitOnSelect="Y"
  (valueChange)="onChange2($event)" required>
</EIPMultiSelectAutoComplete>